import React from "react";
import { useSelector } from 'react-redux';
import PriceArea from "./PriceArea";
import ImageArea from "./ImageArea";
import WishlistButton from "../Sections/WishlistButton";
import { makeStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import { TRAY_LIKE_PLATFORMS } from "../../../Editor/_helpers/constants";
import BuyButtonCard from "./BuyButtonCard";

const useStyles = makeStyles(() => ({
  cardArea: {
    minWidth: 375,
    padding: 5,
    width: 375
  },
  cardContainer: props => ({
    alignItems: "center",
    backgroundColor: "#fff",
    border: props.showBorder ? '1px solid #ccc' : 0,
    borderRadius: 3,
    display: 'flex',
    overflow: "hidden"
  }),
  infoContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: 'center',
    padding: '15px 15px',
  },
  productTitle: props => ({
    color: props.options.titleColor,
    fontSize: 13,
    overflow: 'hidden',
    textAlign: props.textAlign,
    height: `${parseInt(props.titleLinesNumber) * 1.3}em`,
    lineHeight: '1.3em',
    display: '-webkit-box',
    '-webkit-line-clamp': parseInt(props.titleLinesNumber),
    '-webkit-box-orient': 'vertical'
  })
}));

export default function ProductFullCard({ product }) {
  const colors = useSelector(state => state.ThemeReducer.settings.find(s => s.key === 'colors'));
  const productCardSettings = useSelector(state => state.ThemeReducer.settings.find(s => s.key === 'productCardsSettings'));
  const options = _.get(productCardSettings, 'options', {})

  const classes = useStyles({ ...options, ...colors });
  const platform = useSelector(state => state.StoreReducer.platform);

  return (
    <div className={classes.cardArea}>
      <div className={classes.cardContainer}>

        <div style={{ position: 'relative' }}>
          <ImageArea images={_.get(product, 'images', [])} settings={options} />
          <WishlistButton screenType={"ProductFullCard"} />
        </div>

        <div className={classes.infoContainer}>
          <span className={classes.productTitle}>{_.get(product, 'name', 'Título do produto')}</span>

          <PriceArea
            colors={colors}
            displayOldPrice={_.get(product, 'displayOldPrice', 'R$ 100,00')}
            displayPrice={_.get(product, 'displayPrice', 'R$ 90,00')}
            hasPromotionalPrice={_.get(product, 'hasPromotionalPrice', true)}
            isAvailable={true}
            paymentOption={TRAY_LIKE_PLATFORMS.includes(platform) && _.get(product, 'paymentOption', "R$80,00 à vista com desconto ou 10x de R$ 10,00 Sem juros")}
            settings={options}
          />

          {options.showBuyButton && (
            <BuyButtonCard colors={colors} options={options} />
          )}
        </div>
      </div>
    </div>
  );
}